import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { images, octiotUrl } from "../common/images";
import { Toaster } from "react-hot-toast";
import "./Header.css";
import LogOut from "./LogOut";
import { config } from "../../config";
import { canAccessDeviceMove } from "../DeviceMoved/access";

function Header() {
  const [pop, setPop] = useState(false);
  const navigate = useNavigate();
  const houseData = useSelector((state) => state.houseData);

  const login = useSelector((state) => state.login);

  useEffect(() => {
    if (Object.keys(login).length === 0) navigate("/");
  }, [login]);
  const ref = useRef();
  const style = {
    headerContainer: {
      position: "sticky",
      top: 0,
      zIndex: 100,
      height: "8vh",
      width: "100%",
      padding: "0 2%",
      backgroundColor: "#FFFFFF",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    welcome: {
      color: "#212529",
      fontFamily: "manrope",
      fontSize: "22px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "24px",
    },
    login: {
      color: "#000",
      fontFamily: "manrope",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px",
      marginRight: "8px",
    },
  };

  const styleAll = {
    width: document.URL.includes(octiotUrl) ? "70px" : "40.304px",
  };
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setPop(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
  useEffect(() => {

    const faviconUpdate = async () => {
      //grab favicon element by ID
      const favicon = document.getElementById("favicon");

      //check count value, if below 0 we change href property to our red circle image path
      if (document.URL.includes(octiotUrl)) {
        favicon.href = `/OCTIOT.ico`;
        document.title = "Energy Savings";
      }
      //if above 0, we set back to green
      else {
        favicon.href = `/favicon.ico`;
      }
    };
    //run our function here
    faviconUpdate();
  }, []);

  return (
    <div style={{ ...style.headerContainer }}>
      <Toaster />
      <div className="d-flex gap-5 align-items-center">
        <div className="d-flex justify-content-between align-items-center">
          <div style={{ display: "flex" }}>
            <img
              src={
                document.URL.includes(octiotUrl)
                  ? images.octiot
                  : config.pnbProperties.includes(houseData?._id) ? images.pnbLogo : images.loginLogo
              }
              style={{
                width: document.URL.includes(octiotUrl) ? "6.5vw" : "7vw",
                maxHeight: "50px",
                objectFit: "contain",
              }}
            />
          </div>
          {
            config.pnbProperties.includes(houseData?._id) && <div style={{ borderLeft: '1px dashed #000000', paddingLeft: '10px' }}>
              <img src={images.loginLogo} style={{ width: "9vw", maxHeight: "50px", objectFit: "contain" }} />
            </div>
          }</div>
        <div className="d-flex gap-4">
          <div
            className={document.URL.includes('/home') ? 'tabNameActive' : 'tabName'}
            onClick={() => {
              navigate(`/home`);
            }}
          >
            Home
          </div>
          <div
            className={document.URL.includes('/dashboard') ? 'tabNameActive' : 'tabName'}
            onClick={() => {
              navigate(`/dashboard`);
            }}
          >
            Details
          </div>
          <div
            className={document.URL.includes('/schedules') ? 'tabNameActive' : 'tabName'}
            onClick={() => {
              navigate(`/schedules`);
            }}
          >
            Schedules
          </div>
          <div
            className={document.URL.includes('/reports') ? 'tabNameActive' : 'tabName'}
            onClick={() => {
              navigate(`/reports`);
            }}
          >
            Reports
          </div>
          <div
            className={document.URL.includes('/megacontrollers') ? 'tabNameActive' : 'tabName'}
            onClick={() => {
              navigate(`/megacontrollers`);
            }}
          >
            MegaControllers
          </div>
          <div
            className={document.URL.includes('/vrvcontrollers') ? 'tabNameActive' : 'tabName'}
            onClick={() => {
              navigate(`/vrvcontrollers`);
            }}
          >
            VRV Controller
          </div>
          <div
            className={document.URL.includes('/deviceschedule') ? 'tabNameActive' : 'tabName'}
            onClick={() => {
              navigate(`/deviceschedule`);
            }}
          >
            Device Schedule
          </div>
          <div
            className={document.URL.includes('/connectionstatus') ? 'tabNameActive' : 'tabName'}
            onClick={() => {
              navigate(`/connectionstatus`);
            }}
          >
            Connection Status
          </div>
          {canAccessDeviceMove(houseData) && (
            <div
              className={document.URL.includes('/devicemoved') ? 'tabNameActive' : 'tabName'}
              onClick={() => {
                navigate(`/devicemoved`);
              }}
            >
              Device Moved
            </div>
          )}
          {/* <div
            className={document.URL.includes('/deviceStaus') ? 'tabNameActive' : 'tabName'}
            onClick={() => {
              navigate(`/deviceStaus`);
            }}
          >
            Device Status
          </div> */}
          {/* <div
            className={document.URL.includes('/summary') ? 'tabNameActive' : 'tabName'}
            onClick={() => {
              navigate(`/summary`);
            }}
          >
            Summary
          </div> */}
        </div>
      </div>

      <div className="d-flex gap-3 align-items-center">
        <div className="d-flex gap-3">
          <div className="userName">{login?.profile?.first_name}</div>
          <LogOut />
        </div>

      </div>

    </div>
  );
}

export default Header;
